import { useEffect, useState, useRef } from "react";
import BSNavbar from "../../component/Navbar/Navbar";
import Template from "../../util/Template";
import { Modal, Form, Dropdown, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { update, clearForm } from "../../features/saveForm/saveForm";
import { saveForm } from "../../features/saveForm/saveForm";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import { selectEditID } from "../../features/editID/editID";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "./NewComment.css";

const NewComment = () => {
  const [title, setTitle] = useState("");
  const [show, setShow] = useState(false);
  const [showNewImage, setShowNewImage] = useState(false);
  const [content, setContent] = useState(Template);
  const [image, setImage] = useState(null);
  const [imageLink, setImageLink] = useState("");
  const [allImageLink, setAllImageLink] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState({id: "", Name: "", Ch_name: "" });
  const windowWidth = useSelector(selectWindowWidth);
  const editID = useSelector(selectEditID);
  const titleRef = useRef(null);
  const contentRef = useRef(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const typingTimeoutRef = useRef(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dispatch = useDispatch();
  const savedFormData = useSelector(saveForm);

  /**
   * 檢查使用者的登入狀態
   */
  const checkLoginStatus = async () => {
    try {
      await fetch(process.env.REACT_APP_API_URL + '/oauth/me', {
        method: 'POST',
        credentials: 'include'
      }).then(res => res.json());
    } catch {
      navigate('/home');
    }
  };

  const autoResize = () => {
    if (contentRef.current) {
      contentRef.current.style.height = `${contentRef.current.scrollHeight}px`;
    }
    if (titleRef.current) {
      titleRef.current.style.height = "auto";
      titleRef.current.style.height = `${titleRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    autoResize();
  }, [content, title]);

  // Set dropdown menu width to match the toggle width and button height and width
  useEffect(() => {
    if (dropdownRef.current && titleRef.current) {
      dropdownRef.current.style.width = `${titleRef.current.offsetWidth - 20}px`;
    }
    
  }, [dropdownVisible, searchQuery, windowWidth]);

  // Handle clicks outside of dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        titleRef.current && !titleRef.current.contains(event.target) &&
        dropdownRef.current && !dropdownRef.current.contains(event.target)
      ) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [])

  //get the recommendation of course
  const searchCourse = async (query) => {
    const response = await fetch(process.env.REACT_APP_API_URL + `/comments/course?q=${query}`).then(res => res.json());
    if (query.length > 0) {
      const reversed = [...response].reverse();
      setSuggestions(reversed);
    } else {
      setSuggestions(response);
    }
    setDropdownVisible(true);
  }

  // Delayed search to reduce frequent API calls
  useEffect(() => {
    const controller = new AbortController();
    const delaySearch = () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      typingTimeoutRef.current = setTimeout(() => {
        if (searchQuery.trim() !== '') {
          searchCourse(searchQuery);
        } else {
          setSuggestions([]);
        }
      }, 300);
    };

    delaySearch();

    return () => {
      controller.abort();
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, [searchQuery]);

  // handle the selection of dropdown
  const handleDropdownSelect = (courseId, name, chName) => {
    setSelectedCourse({ id: courseId, Name: name, Ch_name: chName });
    setSearchQuery(`${chName} ${name}`);
  }

  /*const handleNavigateToNewCourse = () => {
    navigate("/new-course");
  };*/

  const handleSave = () => {
    const formData = {
      title,
      content,
      selectedCourse,
      allImageLink,
    };
    dispatch(update(formData));
    alert("儲存成功!");
  };

  useEffect(() => {
    if (savedFormData) {
      setTitle(savedFormData.title);
      setContent(savedFormData.content);
      setSelectedCourse(savedFormData.selectedCourse);
      setAllImageLink(savedFormData.allImageLink);
      if(savedFormData.selectedCourse.Ch_name !== '') {
        setSearchQuery(`${savedFormData.selectedCourse.Ch_name} ${savedFormData.selectedCourse.Name}`);
      } else {
        setSearchQuery('');
      }
    }
  }, [savedFormData]);

  const getEditedComment = async () => {
    if (editID.length === 0) return;

    const response = await fetch(
      process.env.REACT_APP_API_URL + `/comments/comment?id=${editID}`,
      {
        method: "GET",
      }
    ).then((res) => res.json());

    setTitle(response.title);
    if(response.name != 'NCTUPLUS') {
      setSearchQuery(`${response.ch_name} ${response.name}`);
      setSelectedCourse({ id: editID, Name: response.name, Ch_name: response.ch_name });
    } else {
      setSearchQuery("")
    }
    setContent(response.content);
  };

  useEffect(() => {
    const controller = new AbortController();

    checkLoginStatus();
    getEditedComment();

    return () => controller.abort();
  }, []);

  const handleSure = (e) => {
    e.preventDefault();

    if (editID.length === 0) {
      handleSubmit();
      dispatch(clearForm());
    } else {
      handleEdit();
    }
  };
  const handleSubmit = async () => {
    const contentWithImage = content + allImageLink;
    try {
      const response = await fetch(process.env.REACT_APP_API_URL + "/comments/me", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title,
          content: contentWithImage,
          is_anonymous: 1,
          id: selectedCourse.id || 16305,
        }),
      });
  
      const data = await response.json();
      console.log("Response data:", data);
  
      if (response.ok) {
        navigate("/comment");
      } else {
        console.error("Request failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  
  /*const handleSubmit = async () => {
    const contentWithImage = content + allImageLink;
    await fetch(process.env.REACT_APP_API_URL + "/comments/me", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title,
        content: contentWithImage,
        is_anonymous: 1,
        id: selectedCourse.id || 16305,
      }),
    }).then(() => {
      navigate("/comment");
    });
  };*/

  const handleEdit = async () => {
    const contentWithImage = content + allImageLink;
    await fetch(process.env.REACT_APP_API_URL + "/comments/me", {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title,
        content: contentWithImage,
        is_anonymous: 1,
        id: editID,
      }),
    }).then(() => {
      navigate("/my-comment");
    });
  };

  const handleImageChange = (e) => {
    e.preventDefault();
    setImage(e.target.files[0]);
    console.log(e.target.files[0]);
  };

  const uploadToImgur = async (imageFile, accessToken) => {
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
      const response = await fetch("https://api.imgur.com/3/upload", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error uploading image to Imgur:", error);
      throw error;
    }
  };

  useEffect(() => {
    console.log(allImageLink);
  }, [allImageLink]);

  const handleUploadImage = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const accessToken = "bac10016bdcef90ea7e4dbb49569372f4ecc9318";
      const imgurResponse = await uploadToImgur(image, accessToken);
      setImageLink(imgurResponse.data.link);
      setAllImageLink(
        (prev) => prev + "\n#image[" + imgurResponse.data.link + "]"
      );
      alert("上傳成功！");
      setShowNewImage(false);
    } catch (error) {
      console.error("Error uploading image to Imgur:", error);
      alert("上傳失敗，請再試一次。");
      setShowNewImage(false);
    }
    setLoading(false);
  };

  return (
    <div style={{ background: '#dfd8cd', minHeight: '100vh', paddingBottom: '20px' }}>
      <BSNavbar bg={'#dfd8cd'}/>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>確認{editID ? "編輯" : "上傳"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>確認要{editID ? "編輯" : "上傳"}心得嗎？</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            取消
          </Button>
          <Button variant="success" onClick={handleSure}>
            確認
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showNewImage}
        onHide={() => {
          setShowNewImage(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>上傳圖片</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {imageLink.length > 0 ?
            <>
              複製以下文字並<span style={{ fontWeight: 'bold' }}>獨立一行</span>貼在內文中以插入圖片：<br />
              <span style={{ color: '#0337a6' }}>
                #image[{imageLink}]
              </span>
            </>
            :
            <Form.Control type="file" accept='.jpg, .jpeg, .png' onChange={handleImageChange} />
          } */}
          <Form.Control
            type="file"
            accept=".jpg, .jpeg, .png"
            onChange={handleImageChange}
          />
        </Modal.Body>
        {imageLink.length === 0 ? (
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowNewImage(false)}>
              取消
            </Button>
            {loading ? (
              <Button variant="success" disabled>
                上傳中...
              </Button>
            ) : (
              <Button variant="success" onClick={handleUploadImage}>
                上傳
              </Button>
            )}
          </Modal.Footer>
        ) : (
          <Modal.Footer>
            {isCopied ? (
              <Button variant="outline-success" disabled>
                已複製！
              </Button>
            ) : (
              <CopyToClipboard
                text={`#image[${imageLink}]`}
                onCopy={() => {
                  setIsCopied(true);
                }}
              >
                <Button variant="success">複製</Button>
              </CopyToClipboard>
            )}
          </Modal.Footer>
        )}
      </Modal>
      <Form
        className="form-container mt-5 mb-5"
        style={{
          width:
            windowWidth >= 1200 ? "50%" : windowWidth > 900 ? "70%" : "80%",
          margin: "auto",
        }}
      >
        <Button
          variant="success"
          style={{ margin: "auto", marginLeft: "15px" }}
          disabled={title.length === 0 || searchQuery.length === 0}
          onClick={() => setShow(true)}
        >
          發布
        </Button>
        {editID.length === 0 && (
          <Button
            variant="warning"
            style={{ margin: "auto", marginLeft: "15px" }}
            disabled={title.length === 0 || searchQuery.length === 0}
            onClick={handleSave}
          >
            儲存
          </Button>
        )}
        <Button
          variant="secondary"
          style={{ margin: "auto", marginLeft: "15px" }}
          onClick={() => {
            setShowNewImage(true);
            setIsCopied(false);
            setImageLink("");
          }}
        >
          新增圖片
        </Button>
        <Form.Control
          className="mt-4"
          as="textarea"
          placeholder="標題"
          rows={1}
          ref={titleRef}
          style={{
            fontSize: windowWidth > 900 ? "50px" : "30px",
            border: "0",
            resize: "none",
            backgroundColor: '#ebe8e4',
            color : '#4b3615',
          }}
          autoFocus
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        {/* dropdown menu */}
        <div className="d-flex align-items-end">
        <Dropdown show={dropdownVisible && suggestions.length > 0}>
          <Dropdown.Toggle as={Form.Control}
            className="mt-4 custom-dropdown-toggle"
            placeholder="課名 & 教授 (必填)"
            rows={1}
            ref={dropdownRef}
            style={{
              fontSize: windowWidth > 900 ? '20px' : '15px',
              border: '0',
              marginLeft: "10px",
              resize: 'none',
              color: '#4b3615',
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          />
          <Dropdown.Menu ref={dropdownRef} style={{ maxHeight: '500px', overflowY: 'auto' }}>
            {suggestions.map((suggestion, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => handleDropdownSelect(suggestion.id, suggestion.name, suggestion.ch_name)}
                style={{
                  fontSize: windowWidth > 900 ? '20px' : '15px',
                  color: '#4b3615'
                }}
              >
                {suggestion.ch_name} {suggestion.name} {suggestion.real_id}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        {/*<OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">新增課程</Tooltip>}
        >
        <Button
          variant="outline-primary"
          className="custom-button"
          style={{
            marginLeft: "10px",
            height: windowWidth > 900 ? "45px" : "35px",
            width: windowWidth > 900 ? "45px" : "40px",
            borderColor: '#4b3615',
            color : '#4b3615',
          }}
          onClick={handleNavigateToNewCourse}
        >
         ＋
        </Button>
        </OverlayTrigger>*/}
        </div>
        <Form.Control
          as="textarea"
          className="mt-3"
          ref={contentRef}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          style={{
            fontSize: windowWidth > 900 ? "20px" : "15px",
            border: "0",
            resize: "none",
            backgroundColor: '#ebe8e4',
            color : '#4b3615',
          }}
        />
      </Form>
    </div >
  );
};

export default NewComment;
